import '../sass/team-block.scss';
import './team-block';
